<template>
    <b-modal v-model="modal.show"
             hide-footer
             centered
             :title="(editing ? 'Editar' : 'Crear') + ' Cargo' "
    >
        <b-form @submit.prevent="validateForm()"
                data-vv-scope="positions"
        >
            <b-row>
                <b-col cols="12">
                    <b-form-group>
                        <label for="code">Código</label>
                        <el-input id="code"
                                  name="code"
                                  size="small"
                                  disabled
                                  v-model="position.code"
                                  data-vv-as=" "
                                  v-validate="'required|min:2|max:10'"
                        />
                        <div class="text-danger small"
                             v-text="errors.first('positions.code')"
                        />
                        <span class="text-success small float-right">
                            El código será generado automáticamente en el momento de la creación
                        </span>
                    </b-form-group>
                </b-col>

                <!-- <b-col cols="12">
                    <b-form-group>
                        <label for="wor_area_id">Área</label>
                        <el-select v-model="position.wor_area_id"
                                   id="wor_area_id"
                                   name="wor_area_id"
                                   filterable
                                   size="small"
                                   placeholder="Seleccione Área"
                                   class="w-100"
                                   no-data-text="No hay datos que coincidan"
                                   no-match-text="No hay datos que coincidan"
                                   data-vv-as=" "
                                   v-validate="''"
                        >
                            <el-option v-for="area in areas"
                                       :key="area.id"
                                       :label="area.name"
                                       :value="area.id"
                            />
                        </el-select>
                        <div class="text-danger small"
                             v-text="errors.first('positions.wor_area_id')"
                        />
                    </b-form-group>
                </b-col> -->

                <b-col cols="12">
                    <b-form-group>
                        <label for="name">Nombre</label>
                        <el-input id="name"
                                  name="name"
                                  size="small"
                                  v-model="position.name"
                                  data-vv-as=" "
                                  v-validate="'required|min:3|max:255'"
                        />
                        <div class="text-danger small"
                             v-text="errors.first('positions.name')"
                        />
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-form-group>
                        <label for="description">Funciones y/o tareas</label>
                        <el-input id="description"
                                  name="description"
                                  size="small"
                                  type="textarea"
                                  v-model="position.description"
                                  data-vv-as=" "
                                  v-validate="'required|min:3|max:255'"
                        />
                        <div class="text-danger small"
                             v-text="errors.first('positions.description')"
                        />
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group>
                        <label for="epps">Epps</label>
                        <el-select id="epps"
                                   name="epps"
                                   v-model="position.epps"
                                   multiple
                                   filterable
                                   size="small"
                                   placeholder="Seleccione Epp"
                                   class="w-100"
                                   no-data-text="No hay datos que coincidan"
                                   no-match-text="No hay datos que coincidan"
                                   data-vv-as=" "
                                   v-validate="'required'"
                        >
                            <el-option v-for="epp in submissionsEpps"
                                       :key="epp.form_submission_id"
                                       :label="epp.label"
                                       :value="epp.form_submission_id"
                            />
                        </el-select>
                        <div class="text-danger small"
                             v-text="errors.first('positions.epps')"
                        />
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group>
                        <label for="exams">Exámenes pre-ocupacionales</label>
                        <el-select v-model="position.exams"
                                   id="exams"
                                   name="exams"
                                   multiple
                                   filterable
                                   size="small"
                                   placeholder="Seleccione Epp"
                                   class="w-100"
                                   allow-create
                                   no-data-text="No hay datos que coincidan"
                                   no-match-text="No hay datos que coincidan"
                                   data-vv-as=" "
                                   v-validate="''"

                        >
                            <el-option v-for="exam in exams"
                                       :key="exam.id"
                                       :label="exam.lista"
                                       :value="exam.id"
                            />
                        </el-select>
                        <div class="text-danger small"
                             v-text="errors.first('positions.exams')"
                        />
                    </b-form-group>
                </b-col>
            </b-row>


            <b-row>
                <div class="w-100 text-center">
                    <hr/>

                    <b-btn variant="primary"
                           class="mx-1"
                           size="sm"
                           @click="validateForm()"
                    >
                        <i class="fa fa-save"/> Guardar
                    </b-btn>
                    <b-btn variant="secondary"
                           class="mx-1"
                           size="sm"
                           @click="setModalShow(false)"
                    >
                        <i class="fa fa-close"/> Cancelar
                    </b-btn>
                </div>
            </b-row>
        </b-form>

    </b-modal>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';

export default {
    name: 'modal',
    computed: {
        ...mapState('positions', [
            'position',
            'editing',
            'modal',
            'areas',
            'epps',
            'exams'
        ]),
        ...mapState('formBuilder', ['submissionsEpps']),
    },
    methods: {
        ...mapActions('positions', [
            'addPosition',
            'updatePosition',
            'fetchAreas',
            'fetchEpps'
        ]),
        ...mapMutations('positions', [
            'resetParams',
            'setModalShow'
        ]),
        validateForm() {
            this.$validator.validateAll('positions')
                .then((result) => {
                    if (result) {
                        if (this.editing) {
                            this.updatePosition();
                        } else {
                            this.addPosition();
                        }
                    }
                });
        }
    },
};
</script>

<style scoped>

</style>
